import React from "react";
import ProTextInput from "./TextField";
import { InputAdornment, Tooltip } from "@mui/material";
import DollerIcon from "../../Assets/IconComponents/DollerIcon";
import ReadOnlyInput from "./ReadOnlyInput";
import PropTypes from "prop-types";
export default function CurrencyField({ rules, mode, isAddMode, label, autoCalculatedIcon, showAutoCalculatedIcon = false, autoCalculatedTooltip, ...rest}) {
  const { canView = false, canAdd = false, canEdit = false } = rest.permission || {};

  const autoCalculatedImg = showAutoCalculatedIcon ? (
    <img src={autoCalculatedIcon} alt="Auto calculated" style={{ width: 14, height: 14, display: "block"}} />
  ) : null;

  const autoCalculatedAdornment = autoCalculatedImg && autoCalculatedTooltip ? (
    <Tooltip title={autoCalculatedTooltip} arrow placement="top">{autoCalculatedImg}</Tooltip>
  ) : autoCalculatedImg;

  if (!canView || (isAddMode && !canAdd)) return null;
  const editModeAllowed = isAddMode ? canAdd : canEdit;
  if (mode === "read" || (mode === "edit" && !editModeAllowed)) return <ReadOnlyInput type="currency" {...rest} rules={rules} label={label} labelAdornment={autoCalculatedAdornment} />;
  return (
    <>
      <ProTextInput
        {...rest}
        label={label}
        placeholder={label}
        type="number"
        rules={rules}
        labelAdornment={autoCalculatedAdornment}
        startAdornment={
          <InputAdornment position="start">
            <DollerIcon />
          </InputAdornment>
        }
      />
    </>
  );
}

CurrencyField.propTypes = {
  mode: PropTypes.oneOf(["read", "edit"]).isRequired,
  isAddMode: PropTypes.bool,
  rules: PropTypes.object
};